import React, { useState } from "react";


const RITI = () => {
  const [activeTab, setActiveTab] = useState("about");

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  return (
    <div className="college-details-container">
      {/* Page Title */}
      <header className="college-header">
        <h1 className="college-title">Rama Pvt. ITI Kutabpur</h1>
        <p className="college-subtitle">
          Recognized by NCTE & Affiliated by K.U.K (Kurukshetra University)
        </p>
      </header>

      {/* Tabs Navigation */}
      <div className="college-tabs">
        <button
          className={`college-tab-button ${activeTab === "about" ? "active" : ""}`}
          onClick={() => handleTabClick("about")}
        >
          About the Program
        </button>
        <button
          className={`college-tab-button ${activeTab === "admission" ? "active" : ""}`}
          onClick={() => handleTabClick("admission")}
        >
          Admission Details
        </button>
        <button
          className={`college-tab-button ${activeTab === "photos" ? "active" : ""}`}
          onClick={() => handleTabClick("photos")}
        >
          Gallery
        </button>
      </div>

      {/* Tab Content */}
      <div className="college-tab-content">
        {activeTab === "about" && (
          <div className="college-tab-panel">
            <Section
              title="ITI (Electrician):"
              content="The ITI Electrician is a 2 year course approved by the NCVT (National Council for Vocational Training). The electrician is a tradesman specializing in electrical wiring of buildings, transmission lines, stationary machines, and related equipment. The electricians may be employed in the installation of new electrical components or maintenance and repair or existing electrical infrastructure."
            />
            <Section
              title="Duration:"
              content="The ITI Electrician Programme shall be of duration of two academic years or of two semesters. However the students shall be permitted to complete the programme requirements within a maximum of three years from the date of admission to the programme"
            />
            <Section
              title="Working Days:"
              content="At least 200 working days per year are required, excluding admission and examination periods. The institution shall work for at least 36 hours per week."
            />
          </div>
        )}

        {activeTab === "admission" && (
          <div className="college-tab-panel">
            <Section
              title="Eligibility:"
              content="10th"
            />
            <Section
              title="Admission Procedure:"
              content="Admission shall be made on merit on the basis of marks obtained in the entrance examination (AIE CET Entrance Examination Result) or any other selection process as per the policy of the University/State Government/UT Administration."
            />
            <Section
              title="Fee:"
              content="The institution shall charge only such fee as prescribed by the affiliating body/State Govt. concerned in accordance with provisions of NCTE (Guidelines for Regulations of tuition fees and other fees chargeable by unaided teacher education institutions) Regulations 2002, as amended from time to time and shall not charge donate, capitation fee etc. from the students."
            />
          </div>
        )}

        {activeTab === "photos" && (
          <div className="college-gallery">
          <img
            src="iti-thumb.jpg"
            alt="College Image 1"
            className="college-gallery-image"
          />
          <img
            src="rce2.jpg"
            alt="College Image 2"
            className="college-gallery-image"
          />
        </div>
        )}
      </div>
    </div>
  );
};

// Reusable Section Component
const Section = ({ title, content }) => {
  return (
    <div className="college-section">
      <h3 className="college-section-title">{title}</h3>
      <p className="college-section-content">{content}</p>
    </div>
  );
};

export default RITI;
